<div class="drop-zone"
     [class.drag-over]="isDragOver()"
     [class.drop-success]="dropSuccess()"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">
    @if (dropSuccess()) {
        <mat-icon class="upload-icon success-icon">check_circle</mat-icon>
        <span class="drop-text">{{ nameControl.value }} – URI bitte unten eingeben</span>
    } @else {
        <mat-icon class="upload-icon">upload_file</mat-icon>
        <span class="drop-text">Datei ablegen um den Namen zu übernehmen</span>
        <span class="drop-hint">URI bitte manuell eingeben – der Dateipfad kann vom Browser nicht ausgelesen werden</span>
        <span class="drop-divider">oder</span>
        <button mat-stroked-button type="button" (click)="fileInput.click()">
            <mat-icon>folder_open</mat-icon>
            Datei auswählen
        </button>
    }
    <input #fileInput type="file" hidden (change)="onFileSelected($event)" />
</div>

<form [formGroup]="uriForm" class="document-upload-form" (ngSubmit)="onSubmit()">

    <mat-form-field class="full-width">
        <mat-label>Dokumentenname</mat-label>
        <input matInput formControlName="displayName" placeholder="z. B. Prüfbericht Q1 2026" />
        @if (nameControl.touched && nameControl.hasError('required')) {
            <mat-error>Dokumentenname ist erforderlich</mat-error>
        }
    </mat-form-field>

<!--    <div class="source-type-toggle">-->
<!--        <label class="source-type-label">Speicherort</label>-->
<!--        <mat-button-toggle-group [value]="sourceType()" (change)="onSourceTypeChange($event.value)">-->
<!--            <mat-button-toggle value="sharepoint">SharePoint</mat-button-toggle>-->
<!--            <mat-button-toggle value="directoryP">Laufwerk P:\</mat-button-toggle>-->
<!--        </mat-button-toggle-group>-->
<!--    </div>-->

    <mat-form-field class="full-width">
<!--        <mat-label>{{ sourceType() === 'sharepoint' ? 'SharePoint-URL' : 'Pfad auf P:\\' }}</mat-label>-->
<!--        @if (sourceType() === 'sharepoint') {-->
<!--            <input #uriInput matInput formControlName="uri"-->
<!--                   placeholder="https://firma.sharepoint.com/sites/Projekt/Freigegebene Dokumente/Bericht.pdf" />-->
<!--            @if (uriControl.touched && uriControl.hasError('required')) {-->
<!--                <mat-error>URL ist erforderlich</mat-error>-->
<!--            } @else if (uriControl.touched && uriControl.hasError('invalidUrl')) {-->
<!--                <mat-error>Bitte eine gültige URL eingeben (z. B. https://…)</mat-error>-->
<!--            }-->
<!--        } @else {-->
<!--            <input #uriInput matInput formControlName="uri"-->
<!--                   placeholder="P:\Projekte\2026\Projekt-X\Bericht.pdf" />-->
<!--            @if (uriControl.touched && uriControl.hasError('required')) {-->
<!--                <mat-error>Pfad ist erforderlich</mat-error>-->
<!--            } @else if (uriControl.touched && uriControl.hasError('invalidPath')) {-->
<!--                <mat-error>Bitte einen gültigen P:\-Pfad eingeben (z. B. P:\Ordner\Datei)</mat-error>-->
<!--            }-->
<!--        }-->

      <input #uriInput matInput formControlName="uri"
             placeholder="P:\Projekte\2026\Projekt-X\Bericht.pdf" />
      @if (uriControl.touched && uriControl.hasError('required')) {
        <mat-error>Pfad ist erforderlich</mat-error>
      }
    </mat-form-field>

    <div class="submit-row">
        <button mat-flat-button color="primary" type="submit" [disabled]="uriForm.invalid">
            <mat-icon>add</mat-icon>
            Dokument hinzufügen
        </button>
    </div>

</form>
